module.exports = flarum.core;